<!--
Author: TangChen
Date: 2018-11-07
Desc: 投资者资料上传，由index.js 配置引入
-->
<template>
    <div :class="'view-investor-data-up view bg-white ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orginfo' }">
                    信息中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-row v-if="!hadUpload" class="investor-data-up">
            <el-alert
                title="注意：上传的文件大小每张不能超过5M，格式类型只支持pdf"
                type="warning"
                show-icon
                :closable="false"
            />
            <pdfUpload v-if="!isIE9" :flag="$route.query.flag || '0'" v-on:success="imgUp" />
            <div v-else class="cant-up">
                <div class="cant-info">
                    为保证上传证件质量，暂不支持IE9浏览器上传认证证件照，推荐使用谷歌、火狐或ie10以上浏览器进行上传认证。
                </div>
                <el-button class="medium" v-on:click.prevent="$router.push({name:'home'})">
                    确定
                </el-button>
            </div>
        </el-row>
        <result v-if="hadUpload" :result="resultObj" v-on:login-now="$router.push({name: 'home'})" v-on:return-login="$router.push({name: 'orginfo'})" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/common/result.vue";
import pdfUpload from "@/components/common/pdfUpload.vue";
export default {
    name: "InvestorDataUp",
    components: {
        result,
        pdfUpload
        /*dataUp*/
    },
    mixins: [mixin],
    data () {
        return {
            isIE9: false,
            hadUpload: false,
            resultObj: {// 结果页面信息
                cla: "register-success",
                msg: "转换资料提交成功！",
                btnMsg: "您的投资者类型转换申请提交成功，请耐心等待审核结果",
                btnL: {
                    text: "返回首页",
                    event: "login-now"
                },
                btnR: {
                    text: "进入信息中心",
                    event: "return-login"
                }
            }
        };
    },
    created () {
        if (window.navigator.userAgent.indexOf("MSIE 9.0") >= 1) {
            this.isIE9 = true;
        }
    },
    methods: {
        imgUp (flag) {
            this.hadUpload = flag;
        }
    }
};
</script>
<style lang="scss">
    /*用户信息 */
    .view-investor-data-up {
        .investor-data-up {
            padding: 20px;
            .comp-result{padding-bottom: 50px;}
            .el-alert__icon{
                float: left;
            }
            .cant-up{
                padding: 20px 0px;
                .cant-info{
                    padding: 5px 16px;
                    line-height: 24px;
                    font-size: 16px;
                }
                .el-button--yellow{margin: 30px 0 0 5px;}
            }
        }
    }
</style>
